import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoader = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "200px",
	height: "200px",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	preserveAspectRatio: "xMidYMid",
	className: "lds-rolling",
	style: { background: "none" },
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		fill: "none",
		stroke: "#2ACC88",
		strokeWidth: 10,
		r: 35,
		strokeDasharray: "164.93361431346415 56.97787143782138",
		transform: "rotate(11.9131 50 50)",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			calcMode: "linear",
			values: "0 50 50;360 50 50",
			keyTimes: "0;1",
			dur: "1s",
			begin: "0s",
			repeatCount: "indefinite"
		})
	})
});
export default SvgLoader;
